export default __webpack_public_path__ + "static/media/Robinhood.1d8c6294.svg";